/**
 * React Query key factory, namespaced per surface so two attachment surfaces mounted on the same
 * page never share a cache entry.
 *
 * Kept separate from any mass-action hook file — mass-action mutations invalidate `list(ownerId)`
 * after a bulk update/destroy but do not own the key shape themselves.
 */
export function attachmentsKeys(entityKey) {
    return {
        all: [entityKey],
        list: (ownerId) => [entityKey, ownerId]
    };
}
